<template>
  <div class="confirm-selection" id="confirmSelection">
    <div class="page-header-container">
      <page-header></page-header>
    </div>
    <logo-header title="选品确认"></logo-header>
    <div class="page-content-container">
      <div class="order-content">
        <div class="address-desc-container">
          <span class="desc">选择收货地址</span>
          <span class="add-address-btn" @click="toAddNewAddess">新增收货地址</span>
        </div>
        <div
          class="address-list"
          :class="showMoreAddress ? '':'hide-more-address'"
          ref="addressList"
        >
          <address-card
            v-for="(address, index) in xbAddressList"
            :key="index"
            :shippingAddress="address"
            :is-small-card="true"
            @selected="onAddressSelected"
          ></address-card>
        </div>
        <div class="tip" v-show="!xbAddressList.length">暂无收货地址，请添加收货地址</div>
        <div class="show-more-address" @click="toggleAddressShow" v-show="xbAddressList.length > 4">
          <i class="icon" :class="showMoreAddress ? 'up':'down'"></i>
          <span class="desc">{{showMoreAddress ? '收起' : '显示更多地址'}}</span>
        </div>
        <div class="commodity-desc">商品信息</div>
        <!-- 购物车表格 -->
        <el-table class="table-container" ref="shoppingCartTable" :data="commodityList">
          <el-table-column label="商品" width="500">
            <template slot-scope="props">
              <div class="img-desc-container">
                <img
                  class="commodity-img"
                  @click="goToProduct(props.row.goodsId)"
                  width="60"
                  height="60"
                  :src="props.row.img"
                  alt="商品图"
                />
                <p class="commodity-desc" @click="goToProduct(props.row.goodsId)">{{props.row.name}}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="规格" prop="normDesc" align="cneter"></el-table-column>
          <el-table-column label="单价" align="cneter">
            <template slot-scope="props">
              <span>￥{{props.row.unitPrice}}</span>
            </template>
          </el-table-column>
          <el-table-column label="数量" prop="amount" align="cneter"></el-table-column>
          <el-table-column label="抽佣比例/金额" align="cneter">
            <template slot-scope="props">
              <span class="subtotal">{{props.row.commissionRate}}%/{{props.row.commissionPrice}}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="live-tiem">
          <el-form ref="form" :model="liveTimeForm" label-width="100px">
            <el-form-item label="选择日期：">
              <el-date-picker
                v-model="liveTimeForm.date"
                class="white"
                type="date"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="时间段：">
              <el-time-picker
                class="white"
                value-format="HH:mm:ss"
                v-model="liveTimeForm.time"
                placeholder="请选择时间"
              ></el-time-picker>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="operation">
        <el-button class="confirm-btn" @click="toSubmitOrder">确认选品</el-button>
      </div>
    </div>
    <div class="page-footer-container">
      <page-footer></page-footer>
    </div>
    <el-dialog title="新增收货地址" :visible.sync="showAddressDialog" :close-on-click-modal="false">
      <el-form :model="addressForm" :rules="addressFormRules" ref="addressForm">
        <el-form-item label="收货人：" label-width="100px" prop="receiver">
          <el-input class="gray" v-model="addressForm.receiver"></el-input>
        </el-form-item>
        <el-form-item label="联系方式：" label-width="100px" prop="telephone">
          <el-input class="gray" v-model="addressForm.telephone"></el-input>
        </el-form-item>
        <el-form-item label="所在区域：" label-width="100px" prop="areaArr">
          <el-cascader v-model="addressForm.areaArr" :options="addressList" :props="cascaderProps"></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址：" label-width="100px" prop="address">
          <el-input class="gray" v-model="addressForm.address"></el-input>
        </el-form-item>
        <el-form-item label label-width="100px">
          <el-checkbox v-model="addressForm.isDefault">设为默认地址</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn" @click="cancelNewAddress">取消</el-button>
        <el-button class="save-btn" @click="addNewAddress">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script >
import PageHeader from "base/xb-base/Header";
import LogoHeader from "base/xb-base/LogoHeader";
import PageFooter from "base/xb-base/Footer";
import AddressCard from "base/xb-base/AddressCard";
import XBSelectionCart from "models/xb/selection-cart.js";
import XBUser from "models/xb/user.js";
import DBAddress from "models/db/address.js";
const xbSelectionCart = new XBSelectionCart();
const xbUser = new XBUser();
const dbAddress = new DBAddress();
const XB_ADDRESS_LIST_MAX_LENGTH = 20;
export default {
  data() {
    return {
      addressList: [],
      cascaderProps: {
        value: "id",
        label: "name",
      },
      showMoreAddress: false,
      xbAddressList: [],
      // 选择的地址id
      selectedAddress: "",
      commodityList: [],
      showAddressDialog: false,
      // 编辑或新增地址
      addressForm: {
        receiver: "",
        telephone: "",
        areaArr: [],
        address: "",
        isDefault: false,
      },
      addressFormRules: {
        receiver: {
          required: true,
          message: "请填写收货人名称",
          trigger: "blur",
        },
        telephone: {
          required: true,
          message: "请填写联系方式",
          trigger: "blur",
        },
        areaArr: {
          required: true,
          message: "请填写所在地区",
          trigger: "blur",
        },
        address: {
          required: true,
          message: "请填写详细地址",
          trigger: "blur",
        },
      },
      liveTimeForm: {
        date: "",
        time: "",
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
    };
  },
  watch: {
    selectedAddress: {
      handler(newVal) {
        let goodsInfo = [];
        this.commodityList.map((commodity) => {
          goodsInfo.push({
            itemId: commodity.skuId,
            quantity: commodity.amount,
            goodsId: commodity.id,
          });
        });
        let data = {
          addresses: newVal,
          goodsInfo: goodsInfo,
        };
      },
    },
  },
  methods: {
    toAddNewAddess() {
      this._showAddressDialog();
    },
    addAddress() {
      // 新增地址
      if (this.xbAddressList.length < XB_ADDRESS_LIST_MAX_LENGTH) {
        this._showAddressDialog();
      } else {
        this.$alert(`最多添加${XB_ADDRESS_LIST_MAX_LENGTH}个地址`, "操作提示", {
          confirmButtonText: "确定",
          type: "warning",
          center: true,
        });
      }
    },
    addNewAddress() {
      this.$refs.addressForm.validate((valid) => {
        if (valid) {
          let {
            receiver,
            telephone,
            areaArr,
            address,
            isDefault,
          } = this.addressForm;
          let data = {
            receiveName: receiver,
            receivePhone: telephone,
            province: areaArr[0],
            city: areaArr[1],
            regions: areaArr[2],
            address: address,
            isDefault: Number(isDefault),
          };
          this._addXbShippingAddress(data);
          // 清空数据域
          this.addressForm.areaArr = [0, 0, 0];
          this.$refs.addressForm.resetFields();
          this._hideAddressDialog();
        } else {
          return false;
        }
      });
    },
    cancelNewAddress() {
      this.$refs.addressForm.resetFields();
      this._hideAddressDialog();
    },
    onAddressSelected(address) {
      if (address.isSelected) {
        // 选中新地址，将之前的地址列表全置为未选中状态
        this.xbAddressList.map((item) => {
          if (item.id === address.id) {
            item.isSelected = true;
          } else {
            item.isSelected = false;
          }
        });
        this.selectedAddress = address.id;
      } else {
        // 取消选中
        this.xbAddressList.map((item) => {
          item.isSelected = false;
        });
      }
    },
    toggleAddressShow() {
      this.showMoreAddress = !this.showMoreAddress;
    },
    toSubmitOrder() {
      let data = {};
      // 先判断有没有选地址
      let selectedAddress = this.xbAddressList.find((item) => item.isSelected);
      if (!selectedAddress) {
        this.$alert(`请先选择收货地址`, "操作提示", {
          confirmButtonText: "确定",
          type: "warning",
          center: true,
        });
        return false;
      }
      if (!this.liveTimeForm.date || !this.liveTimeForm.time) {
        this.$alert(`请选择日期时间`, "操作提示", {
          confirmButtonText: "确定",
          type: "warning",
          center: true,
        });
        return false;
      }
      let nowDate = new Date().getTime();
      let selectDate = new Date(
        this.liveTimeForm.date + " " + this.liveTimeForm.time
      ).getTime();
      if (nowDate >= selectDate) {
        this.$alert(`请选择当前之后的时间`, "操作提示", {
          confirmButtonText: "确定",
          type: "warning",
          center: true,
        });
        this.liveTimeForm.time = "";
        return false;
      }
      data.addressId = selectedAddress.id;
      data.liveTime = this.liveTimeForm.date + " " + this.liveTimeForm.time;
      data.cartIdList = [];
      this.commodityList.map((item) => {
        data.cartIdList.push(item.id);
      });
      this._submitOrder(data);
    },
    _showAddressDialog() {
      this.showAddressDialog = true;
    },
    _hideAddressDialog() {
      this.showAddressDialog = false;
    },
    _getDBAddressMock() {
      dbAddress.getDBAddressMock().then((res) => {
        this.addressList = res;
      });
    },
    // 提交订单
    _submitOrder(data) {
      xbSelectionCart.postXBConfirmSelection(data).then((res) => {
        if (res.success) {
          this.$router.replace("/personal/personal-menu/xb-select-order");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取xb收货地址列表
    _getXbShippingAddressList() {
      xbUser.getXbShippingAddressList().then((res) => {
        if (res.success) {
          this.xbAddressList = [];
          res.result.map((item) => {
            this.xbAddressList.push({
              id: item.id,
              areaArr: [item.province, item.city, item.regions],
              receiver: item.receiveName,
              totalAddress: item.totalAddress,
              address: item.totalAddress,
              telephone: item.receivePhone,
              isDefault: Boolean(item.isDefault),
              isSelected: Boolean(item.isDefault),
            });
          });
          this.selectedAddress = this.xbAddressList[0].id;
          console.log("默认地址id", this.xbAddressList[0].id);
        }
      });
    },
    _addXbShippingAddress(data) {
      xbUser.addXbShippingAddress(data).then((res) => {
        if (res.success) {
          this.$message({
            message: "新增成功",
            center: true,
            type: "success",
            duration: 1000,
          });
          this._getXbShippingAddressList();
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    _confirmOrder(data) {
      xbSelectionCart.postXBSelectionInfo(data).then((res) => {
        if (res.success) {
          this.commodityList = [];
          res.result.map((item) => {
            let normList = JSON.parse(item.specInfo);
            let normDesc = "";
            for (let key in normList) {
              normDesc += `,${normList[key]}`;
            }
            normDesc = normDesc.substring(1);
            this.commodityList.push({
              id: item.id,
              goodsId: item.goodsId,
              skuId: item.itemId,
              img: item.goodsPic
                ? item.goodsPic
                : "http://image.8844it.com/ydb2/goodDefault.png",
              name: item.goodsName,
              normDesc,
              unitPrice: item.marketPrice,
              amount: item.quantity,
              commissionRate: item.commissionRate * 100,
              commissionPrice: (item.commissionRate * item.marketPrice).toFixed(
                2
              ),
            });
          });
          this._getXbShippingAddressList();
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    // 前往商品详情页
    goToProduct(id) {
      let routeUrl = this.$router.resolve({
        path: "/product",
        query: {
          id: id,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
  created() {
    this._getDBAddressMock();
    let data;
    data = {
      cartIdList: JSON.parse(this.$route.query.selectedIds),
    };

    this._confirmOrder(data);
  },
  components: {
    PageHeader,
    LogoHeader,
    PageFooter,
    AddressCard,
  },
};
</script>

<style lang="scss" scoped>
.confirm-selection {
  position: relative;
  min-height: 100vh;
  .page-header-container {
    width: 1200px;
    margin: 0 auto;
  }
  .page-content-container {
    box-sizing: border-box;
    width: 1200px;
    min-height: 10px;
    margin: 0 auto;
    background: #fff;
    padding-bottom: 260px;
    .order-content {
      box-sizing: border-box;
      padding: 0 20px 40px 20px;
      width: 100%;
      border: 1px solid #e3e3e3;
      .address-desc-container {
        display: flex;
        align-items: center;
        height: 60px;
        .desc {
          font-size: 16px;
          color: #606266;
        }
        .add-address-btn {
          margin-left: 20px;
          font-size: 14px;
          color: #3d74f2;
          cursor: pointer;
        }
      }
      .address-list {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        flex-wrap: wrap;
        overflow: hidden;
        &.hide-more-address {
          max-height: 152px;
        }
      }
      .tip {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 152px;
        border: 1px solid #e3e3e3e3;
      }
      .show-more-address {
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        .desc {
          font-size: 12px;
          margin-left: 6px;
        }
        .icon {
          width: 12px;
          height: 12px;
          background-size: 12px 12px;
        }
        .up {
          background-image: url("../../../assets/secondary-menu/up.png");
        }
        .down {
          background-image: url("../../../assets/secondary-menu/down.png");
        }
      }
      .commodity-desc {
        box-sizing: border-box;
        font-size: 16px;
        display: flex;
        padding-top: 8px;
        align-items: flex-start;
        height: 48px;
      }
      .table-container {
        border: 1px solid #e4e4e4;
        .img-desc-container {
          display: flex;
          align-items: center;
          .commodity-desc {
            font-size: 14px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding-left: 32px;
            padding-right: 40px;
            cursor: pointer;
          }
          .commodity-desc:hover {
            color: #df3445;
          }
        }
        .subtotal {
          color: #df3445;
        }
      }
      .live-tiem {
        padding-top: 30px;
        /deep/.el-form {
          display: flex;
          .el-input__prefix {
            height: 40px;
            top: -3px;
            cursor: pointer;
          }
        }
      }
    }
    .operation {
      height: 40px;
      background: #f5f7fa;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .payable-amount {
        font-size: 16px;
        color: #606266;
        .amount {
          color: #df3445;
        }
      }
      .confirm-btn {
        margin-left: 74px;
        box-sizing: border-box;
        border: none;
        width: 100px;
        height: 40px;
        font-size: 16px;
        color: #fff;
        background: rgba(223, 52, 69, 0.75);
        &:hover {
          background: rgba(223, 52, 69, 1);
        }
        &.not-allow-submit {
          pointer-events: none;
          background: #ccc;
        }
      }
    }
  }
  .page-footer-container {
    position: absolute;
    bottom: 0;
    height: 240px;
    width: 100%;
  }
}
</style>

<style lang="scss">
#confirmSelection {
  .el-table {
    .el-table__header-wrapper {
      .el-table__header {
        .has-gutter {
          tr {
            th {
              color: #606266;
              background: #f5f7fa;
            }
          }
        }
      }
    }
  }
  .el-dialog__wrapper {
    .el-dialog {
      width: 440px;
      .el-dialog__header {
      }
      .el-dialog__body {
        .el-form {
          .el-form-item {
            margin-bottom: 20px;
            &:last-child {
              margin-bottom: 0;
            }
            .el-input {
              .el-input__inner {
                width: 300px;
              }
            }
            .el-cascader {
              .el-input {
                .el-input__suffix {
                  right: 0px;
                }
              }
            }
          }
        }
      }
      .el-dialog__footer {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px;
        .btn {
          width: 96px;
          height: 32px;
          border-radius: 4px;
        }
        .cancel-btn {
          margin-right: 24px;
        }
        .save-btn {
          color: #ffffff;
          background: rgba(61, 116, 242, 1);
        }
      }
    }
  }
}
</style>
